/* eslint react/no-array-index-key: 0 */
import React from "react";
import { Field, FieldArray } from "formik";

import { Container, ActionsWrapper, TrashButton, PlusButton } from "./styles";

import { Row } from "../../../ui";
import { Input } from "../input/styles";
import IField from "../../../../interfaces/field";
import Icon from "../../../icon";
import TplGroup from "../tpl-group";

const FieldArrayComponent = FieldArray as any;

type IProps = any & IField;

const MultipleInput: React.FC<IProps> = ({
  name,
  prefixName = "",
  ...el
}: IProps) => (
  <FieldArrayComponent name={name}>
    {({ remove, push }: any) => (
      <Container>
        {el.values[name].length > 0 &&
          el.values[name].map((item: any, index: number) => (
            <Row
              key={index}
              style={{ gap: "7px", marginBottom: "5px", marginTop: "5px" }}
            >
              <TplGroup
                name={`${name}.${index}`}
                prefixName={prefixName}
                title={el.title}
                required={el.required}
                {...el}
              >
                <Field
                  type={el.type || "text"}
                  name={`${name}.${index}`}
                  required={el.required}
                  placeholder={el.placeholder || ""}
                  as={Input}
                />
              </TplGroup>

              <ActionsWrapper>
                {el.values[name].length > 1 && (
                  <TrashButton onClick={() => remove(index)}>
                    <Icon name="trash" />
                  </TrashButton>
                )}
                {index + 1 === el.values[name].length && (
                  <PlusButton onClick={() => push("")}>
                    <Icon name="plus" style={{ width: "15px" }} />
                  </PlusButton>
                )}
              </ActionsWrapper>
            </Row>
          ))}
      </Container>
    )}
  </FieldArrayComponent>
);

export default MultipleInput;
